"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.makeFetchInitialStateForLabelValues = void 0;
const tslib_1 = require("tslib");
const vizportalclient_common_components_1 = require("@tableau/vizportalclient-common-components");
const labelValues_1 = require("./labelValues");
function makeFetchInitialStateForLabelValues(params) {
    const { transform, category, siteLuid } = params;
    const { makeJsonRestApiRequest } = (0, vizportalclient_common_components_1.restApiService)({ siteLuid });
    return (bodyProps, dialogState) => tslib_1.__awaiter(this, void 0, void 0, function* () {
        try {
            const result = yield (0, labelValues_1.getLabelValuesForInitalState)({ transform, category, makeJsonRestApiRequest });
            const labelValues = result
                .get({
                labelValueName: dialogState.labelValueName.toLowerCase(),
                category: category.toLowerCase(),
            });
            if (!labelValues) {
                return dialogState;
            }
            const first = labelValues[0];
            if (!first) {
                return dialogState;
            }
            return first;
        }
        catch (_a) {
            return dialogState;
        }
    });
}
exports.makeFetchInitialStateForLabelValues = makeFetchInitialStateForLabelValues;
//# sourceMappingURL=useLabelValues.js.map